import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import * as appConstants from "../../../constants/index";
import { ProceedButton } from "../../common/login/loginTags";
import SweetAlert from "react-bootstrap-sweetalert";
import bhexport from "../../../assets/payment/qrscan.png";

const JuspayUpiQR = () => {
    const navigate = useNavigate();
    const theme = localStorage.getItem("theme");
    const bookingId = localStorage.getItem("bookingid");
    const subscription = localStorage.getItem("subscription");

    const [loading, setLoading] = useState(false);
    const [qrImage, setQrImage] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [remainingTime, setRemainingTime] = useState(60);
    const [statusAttempts, setStatusAttempts] = useState(0);
    const redirectUrlRef = useRef(null);
    const [redirectUrl, setRedirectUrl] = useState(false);

    const statusIntervalRef = useRef(null);
    const countdownIntervalRef = useRef(null);

    const MAX_STATUS_ATTEMPTS = 10;
    const STATUS_INTERVAL = 6000;
    const stopAllIntervals = () => {
        if (statusIntervalRef.current) clearInterval(statusIntervalRef.current);
        if (countdownIntervalRef.current) clearInterval(countdownIntervalRef.current);
    };

    const cancelBookingTransaction = async () => {
        try {
            const postData = {
                qr: "YES",
                bookType: localStorage.getItem("booking_type"),
                transId: localStorage.getItem("transid"),
                bookingId: bookingId,
                ccode: localStorage.getItem("theaterId"),
            };

            await axios.post(
                `${appConstants.base_url}v1/booking/ticketing/cancel`,
                postData,
                {
                    headers: {
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        city: localStorage.getItem("city"),
                        Authorization: `Bearer ${localStorage.getItem("token") || ""}`, // ✅ CHANGED to localStorage
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        country: appConstants.cname,
                    },
                }
            );
        } catch { }
    };

    const handleTimeout = async () => {
        stopAllIntervals();
        await cancelBookingTransaction();
        navigate("/");
    };

    const startCountdown = () => {
        setRemainingTime(60);

        countdownIntervalRef.current = setInterval(() => {
            setRemainingTime((prev) => {
                if (prev <= 1) {
                    clearInterval(countdownIntervalRef.current);
                    handleTimeout();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };

    const checkPaymentStatus = async (paymentId) => {
        if (statusAttempts >= MAX_STATUS_ATTEMPTS) {
            await handleTimeout();
            return;
        }

        setStatusAttempts((prev) => prev + 1);

        try {
            const postData = {
                bookingId: bookingId,
                paymentId: paymentId,
                bookType:
                    localStorage.getItem("booking_type") === "GIFTCARD"
                        ? "GIFTCARD"
                        : localStorage.getItem("booking_type") === "FOOD"
                        ? "FOOD"
                        : "BOOKING",
            };

            const res = await axios.post(
                `${appConstants.base_url}v1/payment/juspay/status`,
                postData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token") || ""}`, // ✅ CHANGED to localStorage
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        city: localStorage.getItem("city"),
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                    },
                }
            );

            const dt = res.data;

            if (dt.result === "success") {
                const status = dt.output?.p;
                if (status === "PAID") {
                    stopAllIntervals();
                    setLoading(false);
                    localStorage.setItem("booking_ticket", 1);
                    if (redirectUrlRef.current) {
                        const isExternal = redirectUrlRef.current.startsWith("http");
                        if (isExternal) {
                            window.location.href = `${redirectUrlRef.current}`;
                        } else {
                            navigate(`${redirectUrlRef.current}`);
                        }
                    }
                } else if (status !== "PENDING") {
                    stopAllIntervals();
                    setLoading(false);
                    setErrorMsg("Payment Failed or Cancelled");
                    setShowAlert(true);
                }
            }
        } catch {
            stopAllIntervals();
            setLoading(false);
            setErrorMsg("Error checking payment status");
            setShowAlert(true);
        }
    };

    const generateQrPayment = async () => {
        setLoading(true);
        const postData = {
            "transId": localStorage.getItem("transid"),
            "bookingId": localStorage.getItem("bookingid"),
            "bookType": localStorage.getItem("booking_type"),
            "paytype": "UPI",
            "pgtype": "JUSPAY",
            "mandate": subscription == "true" ? true : false,
            "dtmSource": "PVRINOX"
        };

        try {
            const res = await axios.post(
                `${appConstants.base_url}v1/payment/juspay/hmac`,
                postData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token") || ""}`, // ✅ Already localStorage
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        city: localStorage.getItem("city"),
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        country: appConstants.cname,
                    },
                }
            );

            const dt = res.data;

            if (dt.result === "success") {
                const base64QR = dt?.output?.base64_encoded_qr;
                const paymentId = dt?.output?.paymentId;
                redirectUrlRef.current = dt?.output?.forwardUrl;

                if (!base64QR || !paymentId) {
                    throw new Error("QR generation failed");
                }

                setQrImage(base64QR);
                localStorage.setItem("paymentid", paymentId);
                setStatusAttempts(0);

                statusIntervalRef.current = setInterval(() => {
                    checkPaymentStatus(paymentId);
                }, STATUS_INTERVAL);

                startCountdown();
            } else {
                throw new Error(dt.msg || "Payment initiation failed");
            }
        } catch (error) {
            setErrorMsg(error.message || "Something went wrong");
            setShowAlert(true);
            setLoading(false);
        }
    };

    useEffect(() => {
        return () => {
            stopAllIntervals();
        };
    }, []);

    const formattedTime = `${String(Math.floor(remainingTime / 60)).padStart(
        2,
        "0"
    )}:${String(remainingTime % 60).padStart(2, "0")}`;

    return (
        <>
            <SweetAlert
                error
                show={showAlert}
                title={errorMsg}
                onConfirm={() => setShowAlert(false)}
                confirmBtnCssClass={
                    theme === "inoxTheme"
                        ? "confirm-btn-inox border-0"
                        : "confirm-btn-pvr border-0"
                }
            >
                {errorMsg}
            </SweetAlert>

            <div className="payment-form text-center" style={{ position: 'relative', zIndex: 0 }}>
                {/* Full-screen overlay - blocks entire website when QR shows */}
                {qrImage && (
                    <div 
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 9999,
                        }}
                    />
                )}

                {qrImage ? (
                    <div style={{ 
                        marginTop: "20px",
                        position: 'relative',
                        zIndex: 10000 
                    }}>
                        <h5>Scan & Pay</h5>

                        <img
                            src={qrImage}
                            alt="UPI QR"
                            style={{
                                width: "250px",
                                height: "250px",
                                borderRadius: "12px",
                                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                            }}
                        />

                        <p style={{ marginTop: "15px" }}>
                            Open any UPI app and scan this QR
                        </p>

                        <p>Time left: {formattedTime}</p>
                    </div>
                ) : (
                    <div className="genrateqrscan">
                        <img
                            src={bhexport}
                            alt="QR Background"
                            className="qr-bg-image"
                        />

                        <ProceedButton
                            className="btn-proceeds qr-btn"
                            type="button"
                            onClick={generateQrPayment}
                            disabled={loading}
                        >
                            {loading ? (
                                <i
                                    className="pi pi-spin pi-spinner"
                                    style={{ fontSize: "1.5em" }}
                                />
                            ) : (
                                "Generate QR"
                            )}
                        </ProceedButton>
                    </div>
                )}
            </div>
        </>
    );
};

export default JuspayUpiQR;
